export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-list-number-367c39fb6a2280e46f04611d65b4f528.svg";